import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../logo.svg';

function Header() {
  const { pathname } = useLocation();
  const home = pathname === '/';
  const onBlog = pathname.startsWith('/blog');
  const anchor = (id) => (home ? `#${id}` : `/#${id}`);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`nav${scrolled ? ' nav-scrolled' : ''}`}>
      <div className="container nav-inner">
        <Link to="/" aria-label="Oneshoo home">
          <img className="logo-img" src={logo} alt="Oneshoo" />
        </Link>
        <nav className="nav-links">
          <a href={anchor('work')}>Projects</a>
          <a className="nav-about" href={anchor('about')}>About</a>
          <Link className={onBlog ? 'active' : undefined} to="/blog">Blog</Link>
          <a className="nav-cta" href={anchor('contact')}>Contact</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
